import { format } from 'date-fns';

function formatTime(iso: string): string {
    return format(new Date(iso), 'HH:mm');
}

// Fournit les fragments {date} et {time} consommés par la clé i18n
// `appointment.block.button_label` (« RDV {date} - {time} ») côté composant.
export function formatAppointmentButtonParts(startAt: string): { date: string; time: string } {
    return {
        date: format(new Date(startAt), 'd MMMM'),
        time: formatTime(startAt),
    };
}

export function formatAppointmentPopoverDate(startAt: string): string {
    const formatted = format(new Date(startAt), 'EEEE d MMMM yyyy');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function formatAppointmentTimeRange(startAt: string, endAt: string): string {
    return `${formatTime(startAt)} - ${formatTime(endAt)}`;
}
